import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { HIT_BOARD_STATUS } from 'redux/actions/board';
import {
  HIT_REGION_CREATE,
  HIT_REGION_UPDATE,
} from 'redux/actions/organization';
import styled from 'styled-components';
import './index.scss';
import initialValues from './initialValues';
import validationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

function WorkerType(props) {
  const { t } = props;
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.dataActivityType) {
          dispatch({
            type: HIT_REGION_UPDATE,
            payload: {
              data: {
                ...formik.values,
                region_id: props.dataActivityType.region_id,
              },
              id: props.ids,
            },
          });
        } else {
          dispatch({
            type: HIT_REGION_CREATE,
            payload: {
              ...formik.values,
              board_id: localStorage.getItem('board_id'),
            },
          });
        }

        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        dispatch({
          type: HIT_BOARD_STATUS,
          payload: {
            status: 'failed',
            message: error.message,
          },
        });
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });
  useEffect(() => {
    if (props.typeForm !== 'create') {
      formik.setValues({
        name: props.dataActivityType?.name,
        description: props.dataActivityType?.description || '',
      });
    }
  }, [props.dataActivityType, props.modal]);

  useEffect(() => {
    if (props.showModal) {
      formik.resetForm();
    }
  }, [props.showModal]);

  return (
    <>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('wla.analytics.table.region')}`}
              </Label>
              <div className="cs_modal-region">
                <div>
                  <Input
                    isError={formik.touched.name && Boolean(formik.errors.name)}
                    validateMessage={formik.errors.name}
                    type="text"
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name || ''}
                    placeholder={t('company.region_name')}
                  />
                </div>
                <div>
                  <Input
                    isError={
                      formik.touched.description
                      && Boolean(formik.errors.description)
                    }
                    validateMessage={formik.errors.description}
                    type="text"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description || ''}
                    placeholder={t('board.desc')}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('region_list'),
        )}
    </>
  );
}

export default WorkerType;
